import get from 'lodash/get'

export default {
  methods: {
    $lodashGet: get,
  },
}
